/** Valantis stHYPE — `balancePerShare()` returns the 1e18-scaled
 *  HYPE-per-share rate. wstHYPE wraps the same underlying state, so
 *  this is the rate for both stHYPE and wstHYPE. */
export const ValantisStHypeAbi = [
  {
    name: 'balancePerShare',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint256' }],
  },
] as const
